import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { RiskZonesDetailSidebar } from "../../containers/RiskZonesDetailSidebar"
import { RiskZonesSidebar } from "../../containers/RiskZonesSidebar"

import { RiskZoneValidator } from "../RiskZoneValidator"

import * as Styled from "./RiskZonesSidebarRouter.styled"

export function RiskZonesSidebarRouter() {
    const isMobile = useIsMobileDevice()

    const sidebarRoutes = useMemo(() => ([
        { path: "/", element: <RiskZonesSidebar /> },
        { path: "/:road", element: <RiskZonesSidebar /> },
        { path: "/:road/:riskZoneId", element: <RiskZoneValidator><RiskZonesDetailSidebar /></RiskZoneValidator> },
    ]), [])


    return <Styled.Sidebar shadowed={!isMobile}>{useRoutes(sidebarRoutes)}</Styled.Sidebar>
}
